import * as React from 'react';
import TopBar from '../Bars/TopBar';
import ErrorBoundary from '../../AdvancedComponents/ErrorBoundary';
export default (props: { children?: React.ReactNode }) => (
    <ErrorBoundary>
        <div className="internalManual">
            <TopBar />
            <div className="main">
                <ErrorBoundary>
                    <div>
                        <div className="scrollPage">
                            {props.children}
                        </div>
                    </div>
                </ErrorBoundary>
            </div>
        </div>
    </ErrorBoundary>
);
